import {
  initiateStripeCheckout,
} from "@/common/functions";
import { createModuleResetter } from "@/helpers/utils";

import {
  STRIPE_INIT_CHECKOUT,
} from "../actions";
import { RESET_STORE } from "../mutations";

const getInitState = () => ({});

const getters = {};

const mutations = {
  [RESET_STORE]: createModuleResetter(getInitState),
};

const actions = {
  async [STRIPE_INIT_CHECKOUT](_, payload) {
    try {
      const { data } = await initiateStripeCheckout({ ...payload });

      return { ...data };
    } catch (error) {
      return { isSuccess: false };
    }
  },
};

export default {
  namespaced: true,
  state: getInitState(),
  actions,
  mutations,
  getters,
};
